import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useQuery } from '@tanstack/react-query';
import { ITransdermalFentanylConfig } from '../MME.ts';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';

export function useGetFentanylDoseOptions(versionID?: number) {
    return useQuery<ITransdermalFentanylConfig | null>({
        queryKey: [QueryKeys.fentanylDoseOptions, versionID],
        queryFn: async () => {
            return await MMEApi.getTransdermalFentanylConfig(versionID);
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
